<div class="row" *ngIf="isComercial">
  <div class="col-md col-xs col-xl col-sm wd-100-pc">
    <mat-card class="mat-elevation-z8 wd-100-pc">
      <form [formGroup]="formulario" (keydown.enter)="$event.preventDefault()">
        <div class="row">
          <div class="col-md col-xs col-xl col-sm">
            <p class="tituloLeft">{{step}}</p>
          </div>
          <div class="col-lg-2 col-md-2 col-xs-2 col-xl-2 col-sm-2 text-right">
            <i class="fa fa-window-minimize iconMenu" matTooltip="Minimizar" (click)="changeCollapse()"
              *ngIf="!collapseCard"></i>
            <i class="fa fa-window-maximize iconMenu" matTooltip="Maximizar" (click)="changeCollapse()"
              *ngIf="collapseCard"></i>
          </div>
        </div>
        <mat-card-content *ngIf="!collapseCard">
          <div class="row pt-3">
            <div class="col-md">
              <mat-form-field class="wd-100-pc" appearance="{{formFieldAppearance}}" floatLabel="{{formFieldFloatLabel}}">
                <mat-label class="InputLabelColor">Controle de Análise (CA)</mat-label>
                <input matInput id="txtContrAnalCA" #txtContrAnalCA maxlength="10"
                  formControlName="controle_analise_ca" (blur)="getDadosMateriaPrima()">
                <i matSuffix class="{{iconEnableField}}"></i>
                <mat-hint align="start" class="InputLabelDetailsColor">
                </mat-hint>
                <mat-hint align="end">{{txtContrAnalCA.value.length}} / 10</mat-hint>
                <mat-error>{{hasErrorFormControl(formulario.controls.controle_analise_ca)}}
                </mat-error>
              </mat-form-field>
            </div>
            <div class="col-md">
              <mat-form-field class="wd-100-pc" appearance="{{formFieldAppearance}}" floatLabel="{{formFieldFloatLabel}}">
                <mat-label class="InputLabelColor">Prévia e Número da Passada</mat-label>
                <input matInput id="txtCheckNumeroPassada" #txtCheckNumeroPassada maxlength="10"
                  formControlName="previa_numero_passada" currencyMask
                  [options]="{ thousands: '.', decimal: ',', precision: 0 }" (blur)="checkPreviaNumeroPassada()">
                <i matSuffix class="{{iconEnableField}}"></i>
                <mat-hint align="start" class="InputLabelDetailsColor">Somente Números de 0 a 15 são aceitos, sendo 0 a prévia
                </mat-hint>
                <mat-hint align="end">{{txtCheckNumeroPassada.value.length}} / 10</mat-hint>
                <mat-error>{{hasErrorFormControl(formulario.controls.previa_numero_passada)}}
                </mat-error>
              </mat-form-field>
            </div>
            <div class="col-md">
              <mat-form-field class="wd-100-pc" appearance="{{formFieldAppearance}}" floatLabel="{{formFieldFloatLabel}}">
                <mat-label class="InputLabelColor">Número da Regulagem</mat-label>
                <mat-select #txtNumeroRegulagem formControlName="numero_da_regulagem" disableCenteringOption>
                  <input matInput type="text" class="form-control filterTxt" placeholder="Selecione um campo"
                    (keyup)="createFilterNumeroRegulagem($event.target.value)">
                  <mat-option *ngFor="let item of listNumeroDaRegulagem" [value]="item.name">
                    {{item.name | uppercase}}
                  </mat-option>
                </mat-select>
                <i matSuffix class="{{iconEnableField}}"></i>
                <mat-hint align="start" class="InputLabelDetailsColor"></mat-hint>
                <mat-error>{{hasErrorFormControl(formulario.controls.numero_da_regulagem)}}</mat-error>
              </mat-form-field>
            </div>
          </div>
        </mat-card-content>
      </form>
    </mat-card>
  </div>
</div>

<div class="row" *ngIf="isBasica">
  <div class="col-md col-xs col-xl col-sm wd-100-pc">
    <mat-card class="mat-elevation-z8 wd-100-pc">
      <form [formGroup]="formulario" (keydown.enter)="$event.preventDefault()">
        <div class="row">
          <div class="col-md col-xs col-xl col-sm">
            <p class="tituloLeft">{{step}}</p>
          </div>
          <div class="col-lg-2 col-md-2 col-xs-2 col-xl-2 col-sm-2 text-right">
            <i class="fa fa-window-minimize iconMenu" matTooltip="Minimizar" (click)="changeCollapse()"
              *ngIf="!collapseCard"></i>
            <i class="fa fa-window-maximize iconMenu" matTooltip="Maximizar" (click)="changeCollapse()"
              *ngIf="collapseCard"></i>
          </div>
        </div>
        <mat-card-content *ngIf="!collapseCard">
          <div class="row pt-3">
            <div class="col-md">
              <mat-form-field class="wd-100-pc" appearance="{{formFieldAppearance}}" floatLabel="{{formFieldFloatLabel}}">
                <mat-label class="InputLabelColor">Controle de Análise (CA)</mat-label>
                <input matInput id="txtContrAnalCA" #txtContrAnalCA maxlength="10"
                  formControlName="controle_analise_ca" (blur)="getDadosMateriaPrima()">
                <i matSuffix class="{{iconEnableField}}"></i>
                <mat-hint align="start" class="InputLabelDetailsColor">
                </mat-hint>
                <mat-hint align="end">{{txtContrAnalCA.value.length}} / 10</mat-hint>
                <mat-error>{{hasErrorFormControl(formulario.controls.controle_analise_ca)}}
                </mat-error>
              </mat-form-field>
            </div>
            <div class="col-md">
              <mat-form-field class="wd-100-pc" appearance="{{formFieldAppearance}}" floatLabel="{{formFieldFloatLabel}}">
                <mat-label class="InputLabelColor">Prévia e Número da passada</mat-label>
                <mat-select #txtPreviaNumeroPassada formControlName="previa_numero_passada_basica"
                  disableCenteringOption>
                  <input matInput type="text" class="form-control filterTxt" placeholder="Selecione um campo"
                    (keyup)="createFilterPeneira($event.target.value)">
                  <mat-option *ngFor="let item of listPreviaNumeroPassada" [value]="item.name">
                    {{item.name | uppercase}}
                  </mat-option>
                </mat-select>
                <i matSuffix class="{{iconEnableField}}"></i>
                <mat-hint align="start" class="InputLabelDetailsColor"></mat-hint>
                <mat-error>{{hasErrorFormControl(formulario.controls.previa_numero_passada_basica)}}</mat-error>
              </mat-form-field>
            </div>
            <div class="col-md">
              <mat-form-field class="wd-100-pc" appearance="{{formFieldAppearance}}" floatLabel="{{formFieldFloatLabel}}">
                <mat-label class="InputLabelColor">Número de regulagem no passe</mat-label>
                <mat-select #txtRegulagemPaffe formControlName="regulagem_passe" disableCenteringOption>
                  <input matInput type="text" class="form-control filterTxt" placeholder="Selecione um campo"
                    (keyup)="createFilterPeneira($event.target.value)">
                  <mat-option *ngFor="let item of listRegulagemPasse" [value]="item.name">
                    {{item.name | uppercase}}
                  </mat-option>
                </mat-select>
                <i matSuffix class="{{iconEnableField}}"></i>
                <mat-hint align="start" class="InputLabelDetailsColor"></mat-hint>
                <mat-error>{{hasErrorFormControl(formulario.controls.regulagem_passe)}}</mat-error>
              </mat-form-field>
            </div>
          </div>
        </mat-card-content>
      </form>
    </mat-card>
  </div>
</div>
